export default {
  items: [
    {
      name: 'Painel Produção',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'warning',
        text: 'PRO'
      }
    },
    {
      title: true,
      name: 'Cadastros',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Básicos',
      url: '/cadastros/clientes',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Clientes',
          url: '/cadastros/clientes/index',
          icon: 'icon-folder-alt'
        },
        {
          name: 'Layout de Importação',
          url: '/cadastros/layout-importacao/list',
          icon: 'icon-settings'
        }
      ]
    },
    {
      title: true,
      name: 'Relatorios',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Financeiro',
      url: '/relatorios',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Contas a Pagar',
          url: '/relatorios/relapagar',
          icon: 'icon-printer'
        },
        {
          name: 'Contas a Pagas',
          url: '/relatorios/relpago',
          icon: 'icon-printer'
        },
        {
          name: 'Contas a Receber',
          url: '/relatorios/relareceber',
          icon: 'icon-printer'
        },
        {
          name: 'Contas a Recebidas',
          url: '/relatorios/relrecebido',
          icon: 'icon-printer'
        },
        {
          name: 'Livro Caixa',
          url: '/relatorios/relcaixalivro',
          icon: 'icon-printer'
        },
        {
          name: 'Movimento do Caixa',
          url: '/relatorios/relcaixamovimento',
          icon: 'icon-printer'
        }
      ]
    },
    {
      name: 'Vendas e Estoque',
      url: '/relatorios',
      icon: 'icon-basket',
      children: [
        {
          name: 'Relatório de Vendas',
          url: '/relatorios/relvendas',
          icon: 'icon-printer'
        },
        {
          name: 'Relatório de Pedidos',
          url: '/relatorios/relpedidovenda',
          icon: 'icon-printer'
        },
        {
          name: 'Relatório de NF-e',
          url: '/relatorios/relnotafiscal',
          icon: 'icon-printer'
        },
        {
          name: 'Relatorio Operacional',
          url: '/relatorios/reloperacaovenda',
          icon: 'icon-printer'
        },
        {
          name: 'Relatório de Estoque',
          url: '/relatorios/relestoque',
          icon: 'icon-printer'
        },
        {
          name: 'Dashboard Estoque',
          url: '/estoque/dashboard',
          icon: 'icon-speedometer'
        }

      ]
    },
    {
      name: 'Produção',
      url: '/relatorios',
      icon: 'icon-settings',
      children: [
        {
          name: 'Produção por Fórmula',
          url: '/relatorios/relproducaoformula',
          icon: 'icon-printer'
        },
        {
          name: 'Abate',
          url: '/relatorios/relabate',
          icon: 'icon-printer'
        },
        {
          name: 'Compra de Gado',
          url: '/relatorios/relcompragado',
          icon: 'icon-printer'
        }
      ]
    },
    {
      title: true,
      name: 'Consultas',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Financeiro',
      url: '/consultas',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Débitos de Clientes',
          url: '/consultas/areceberporcliente',
          icon: 'icon-book-open'
        }
      ]
    },
    {
      name: 'Expedição',
      url: '/expedicao',
      icon: 'icon-speedometer',
      children: [
        {
          name: 'Expedição de Volumes',
          url: '/expedicao/volumes/index',
          icon: 'icon-layers'
        },
        {
          name: 'Expedição de Vendas',
          url: '/expedicao/vendas/index',
          icon: 'icon-basket-loaded'
        },
        {
          name: 'Conferencia de Vendas',
          url: '/expedicao/conferencia/vendas/index',
          icon: 'icon-check'
        },
        {
          name: 'Ordem de Entrega',
          url: '/expedicao/ordementrega/listagem',
          icon: 'icon-location-pin'
        }
      ]
    },
    {
      name: 'Produção',
      url: '/producao',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Dashboard Produção',
          url: '/producao/formula/dashboard',
          icon: 'icon-speedometer'
        },
        {
          name: 'Rastreabilidade Fórmula',
          url: '/producao/formula-rastreabilidade/listagem',
          icon: 'icon-share-alt'
        }
      ]
    } /* ,
    {
      name: 'Produção',
      url: '/relatorios',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Abate',
          url: '/relatorios/relabate',
          icon: 'icon-printer'
        },
        {
          name: 'Compra de Gado',
          url: '/relatorios/relcompragado',
          icon: 'icon-printer'
        }
      ]
    },
    {
      title: true,
      name: 'Theme',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Colors',
      url: '/theme/colors',
      icon: 'icon-drop'
    },
    {
      name: 'Typography',
      url: '/theme/typography',
      icon: 'icon-pencil'
    },
    {
      title: true,
      name: 'Components',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Base',
      url: '/base',
      icon: 'icon-puzzle',
      children: [
        {
          name: 'Breadcrumbs',
          url: '/base/breadcrumbs',
          icon: 'icon-puzzle'
        },
        {
          name: 'Cards',
          url: '/base/cards',
          icon: 'icon-puzzle'
        },
        {
          name: 'Carousels',
          url: '/base/carousels',
          icon: 'icon-puzzle'
        },
        {
          name: 'Collapses',
          url: '/base/collapses',
          icon: 'icon-puzzle'
        },
        {
          name: 'Forms',
          url: '/base/forms',
          icon: 'icon-puzzle'
        },
        {
          name: 'Jumbotrons',
          url: '/base/jumbotrons',
          icon: 'icon-puzzle'
        },
        {
          name: 'List Groups',
          url: '/base/list-groups',
          icon: 'icon-puzzle'
        },
        {
          name: 'Navs',
          url: '/base/navs',
          icon: 'icon-puzzle'
        },
        {
          name: 'Paginations',
          url: '/base/paginations',
          icon: 'icon-puzzle'
        },
        {
          name: 'Popovers',
          url: '/base/popovers',
          icon: 'icon-puzzle'
        },
        {
          name: 'Progress Bars',
          url: '/base/progress-bars',
          icon: 'icon-puzzle'
        },
        {
          name: 'Switches',
          url: '/base/switches',
          icon: 'icon-puzzle'
        },
        {
          name: 'Tables',
          url: '/base/tables',
          icon: 'icon-puzzle'
        },
        {
          name: 'Tooltips',
          url: '/base/tooltips',
          icon: 'icon-puzzle'
        }
      ]
    },
    {
      name: 'Buttons',
      url: '/buttons',
      icon: 'icon-cursor',
      children: [
        {
          name: 'Standard Buttons',
          url: '/buttons/standard-buttons',
          icon: 'icon-cursor'
        },
        {
          name: 'Button Groups',
          url: '/buttons/button-groups',
          icon: 'icon-cursor'
        },
        {
          name: 'Dropdowns',
          url: '/buttons/dropdowns',
          icon: 'icon-cursor'
        },
        {
          name: 'Social Buttons',
          url: '/buttons/social-buttons',
          icon: 'icon-cursor'
        }
      ]
    },
    {
      name: 'Icons',
      url: '/icons',
      icon: 'icon-star',
      children: [
        {
          name: 'Flags',
          url: '/icons/flags',
          icon: 'icon-star',
          badge: {
            variant: 'success',
            text: 'NEW'
          }
        },
        {
          name: 'Font Awesome',
          url: '/icons/font-awesome',
          icon: 'icon-star',
          badge: {
            variant: 'secondary',
            text: '4.7'
          }
        },
        {
          name: 'Simple Line Icons',
          url: '/icons/simple-line-icons',
          icon: 'icon-star'
        }
      ]
    },
    {
      name: 'Charts',
      url: '/charts',
      icon: 'icon-pie-chart'
    },
    {
      name: 'Notifications',
      url: '/notifications',
      icon: 'icon-bell',
      children: [
        {
          name: 'Alerts',
          url: '/notifications/alerts',
          icon: 'icon-bell'
        },
        {
          name: 'Badges',
          url: '/notifications/badges',
          icon: 'icon-bell'
        },
        {
          name: 'Modals',
          url: '/notifications/modals',
          icon: 'icon-bell'
        }
      ]
    },
    {
      name: 'Widgets',
      url: '/widgets',
      icon: 'icon-calculator',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      divider: true
    },
    {
      title: true,
      name: 'Extras'
    },
    {
      name: 'Pages',
      url: '/pages',
      icon: 'icon-star',
      children: [
        {
          name: 'Login',
          url: '/pages/login',
          icon: 'icon-star'
        },
        {
          name: 'Register',
          url: '/pages/register',
          icon: 'icon-star'
        },
        {
          name: 'Error 404',
          url: '/pages/404',
          icon: 'icon-star'
        },
        {
          name: 'Error 500',
          url: '/pages/500',
          icon: 'icon-star'
        }
      ]
    },
    {
      name: 'Download CoreUI',
      url: 'http://coreui.io/vue/',
      icon: 'icon-cloud-download',
      class: 'mt-auto',
      variant: 'success'
    },
    {
      name: 'Try CoreUI PRO',
      url: 'http://coreui.io/pro/vue/',
      icon: 'icon-layers',
      variant: 'danger'
    }
  */
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js